const letterSpacing = "tracking-normal";
export type FontSize =
  | "display"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "body-l"
  | "body-md"
  | "body-s"
  | "body-xs";
export type FontWeight = "font-regular" | "font-medium" | "font-semibold" | "font-bold";
export const FontStyles: Record<FontSize, string> = {
  display: `text-small-display md:text-display ${letterSpacing}`,
  h1: `text-small-h1 md:text-h1 ${letterSpacing}`,
  h2: `text-small-h2 md:text-h2 ${letterSpacing}`,
  h3: `text-small-h3 md:text-h3 ${letterSpacing}`,
  h4: `text-small-h4 md:text-h4 ${letterSpacing}`,
  h5: `text-small-h5 md:text-h5 ${letterSpacing}`,
  h6: `text-small-h6 md:text-h6 ${letterSpacing}`,
  "body-l": `text-small-body-l md:text-body-l ${letterSpacing}`,
  "body-md": `text-small-body-md md:text-body-md ${letterSpacing}`,
  "body-s": `text-small-body-s md:text-body-s ${letterSpacing}`,
  "body-xs": `text-small-body-xs md:text-body-xs ${letterSpacing}`,
};
